exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header{background-color:transparent;position:absolute;width:100%;top:0}.navbar-brand img{margin-top:-50px;max-width:70px}a.nav-link-main.nav-link{padding-left:10px}@media only screen and (max-width:992px){.navbar-brand img{margin-top:0}}@media only screen and (max-width:768px){.become-a-protector-ln{background-color:#f07d00;color:#fff!important}}", ""]);

// exports
